export default () => '99999-999'
